<template>
  <Modal v-model="choiceDeviceModal" width="1200" footer-hide>
    <p slot="header" class="text-center">添加资产</p>
    <Row :gutter="8" class="m-b-5">
      <i-col span="4">
        <Select
          size="small"
          placeholder="所属资产"
          v-model="query.assetId"
          @on-change="handleChangeAsset"
        >
          <i-option
            v-for="item in assetArray"
            :key="'asset_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="4">
        <Select
          size="small"
          placeholder="资产类型"
          v-model="query.devicemodel"
          clearable
        >
          <i-option
            v-for="item in childDeviceModelArray"
            :key="'smallmodel_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="4">
        <Select
          size="small"
          placeholder="站点（可搜索）"
          filterable
          v-model="query.stationId"
          clearable
        >
          <i-option
            v-for="item in stationArray"
            :key="'qStation_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>

      <i-col span="8" class="m-b-5">
        <i-input
          size="small"
          v-model="query.keyword"
          placeholder="支持：编码模糊查询"
        ></i-input>
      </i-col>
      <i-col span="4">
        <Button
          size="small"
          type="primary"
          icon="ios-search"
          class="m-r-10"
          @click="SearchData"
          >搜索</Button
        >
        <Checkbox v-model="onlyChk">只看已选</Checkbox>
      </i-col>
    </Row>
    <Table
      size="small"
      :columns="columnManagedata"
      :data="tableData"
      :loading="tableLoading"
      stripe
    ></Table>
    <div class="paging_style">
      <Page
        size="small"
        :total="total"
        :page-size="query.pageSize"
        show-total
        show-elevator
        :current="query.pageNumber"
        @on-change="changePage"
      ></Page>
    </div>

    <Spin fix size="large" v-if="spinShow">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>提交中...</div>
    </Spin>
  </Modal>
</template>

<script>
import { getMaintenanceAssetList, getExistDeviceModelList } from '@/api/rim/asset'
import { getStationByAssetId } from '@/api/rim/station'
import { saveSpaceDevice } from '@/api/product/leaseSpace'
import { getEstateDevicePage3 } from '@/api/rim/device'

export default {
  props: {
    deviceArray: {
      type: Array
    }
  },
  data () {
    return {
      choiceDeviceModal: false,
      total: 0,

      assetArray: [],
      parentDeviceModelArray: [],
      childDeviceModelArray: [],
      stationArray: [],

      query: {
        pageNumber: 1,
        pageSize: 10,
        deviceBigmodel: 3, // 默认值，仅取车站商业
        assetId: undefined,
        devicemodel: undefined,
        stationId: undefined,
        keyword: ''
      },
      choiceDeviceIdArray: [],
      tableLoading: false,
      spinShow: false,
      tableData: [],
      onlyChk: false,
      columnManagedata: [
        { title: '编号', key: 'code' },
        { title: '类型', align: 'center', key: 'devicemodelName' },
        { title: '站点', align: 'center', key: 'stationName' },
        { title: '出口', align: 'center', key: 'exits' },
        { title: '楼层', align: 'center', key: 'floor' },
        { title: '位置', align: 'center', key: 'positionName' },
        { title: '面积（㎡）', align: 'center', key: 'area' },
        { title: '状态', align: 'center', key: 'enabledName' },
        { title: '经营方', align: 'center', ellipsis: true, tooltip: true, key: 'manageUnitName' },
        {
          title: '租赁类型',
          align: 'center',
          key: 'openLease',
          render: (h, params) => {
            return h('span', params.row.openLease ? '开放租赁' : '自用')
          }
        },
        {
          title: '通电',
          align: 'center',
          key: 'electric',
          render: (h, params) => {
            return h('span', params.row.electric ? '是' : '否')
          }
        },
        {
          title: '通水',
          align: 'center',
          key: 'waterSupply',
          render: (h, params) => {
            return h('span', params.row.waterSupply ? '是' : '否')
          }
        },
        {
          title: '通气',
          align: 'center',
          key: 'gasSupply',
          render: (h, params) => {
            return h('span', params.row.gasSupply ? '是' : '否')
          }
        },
        {
          title: '消防验收',
          align: 'center',
          key: 'fireApproval',
          render: (h, params) => {
            return h('span', params.row.fireApproval ? '是' : '否')
          }
        },
        {
          title: '已加入招商内容',
          align: 'center',
          key: 'spaceDeviceVOS',
          render: (h, params) => {
            return h('span', params.row.spaceDeviceVOS.map(item => { return item.spaceName }).toString())
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            const addButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.chkDevice(params.row.id)
                  }
                }
              },
              '加入'
            )

            return h('div', [this.choiceDeviceIdArray.includes(params.row.id) ? '-' : addButton])
          }
        }
      ]
    }
  },
  mounted () {
    this.getAssetData()
  },
  methods: {
    showModal () {
      // this.publicityInfoModel.investId = this.investmentId
      // listSinInBusiness({ investId: this.investmentId }).then((res) => {
      //   this.businessArray = res.filter((x) => x.orderStatus === 1)
      // })
      this.initPageData()
      this.choiceDeviceModal = true
    },
    hideModal () {
      this.choiceDeviceModal = false
    },
    initPageData () {
      if (this.onlyChk && !this.choiceDeviceIdArray.length) {
        this.tableData = []
        this.total = 0
        this.query.pageNumber = 1
      } else {
        this.tableLoading = true
        this.query.deviceIdList = this.onlyChk ? JSON.stringify(this.choiceDeviceIdArray) : null
        getEstateDevicePage3(this.query).then((response) => {
          this.total = response.totalRow
          this.tableData = response.list
          this.query.pageNumber = response.pageNumber
          this.tableLoading = false
        })
      }
    },

    getAssetData () {
      getMaintenanceAssetList().then(res => {
        if (res && !res.errcode) {
          this.assetArray = res
          this.query.assetId = this.assetArray.length ? this.assetArray[0].id : undefined
          this.handleChangeAsset()
        } else {
          this.assetArray = []
        }
      })
    },
    handleChangeAsset () {
      this.getBigModelData()
      this.getStationData()
    },
    getBigModelData () {
      getExistDeviceModelList({ assetId: this.query.assetId, deviceBigModel: this.query.deviceBigmodel }).then(res => {
        if (res && !res.errcode) {
          this.parentDeviceModelArray = res
          // this.$store.commit('set_big_model_array', this.parentDeviceModelArray)
          // this.query.deviceBigmodel = this.parentDeviceModelArray.length ? this.parentDeviceModelArray[0].id : undefined
          this.handleChangeBigmodel()
        } else {
          this.parentDeviceModelArray = []
        }
      })
    },
    handleChangeBigmodel () {
      const result = this.parentDeviceModelArray.find(x => x.id === this.query.deviceBigmodel)
      this.childDeviceModelArray = result && result.children ? result.children : []
    },
    getStationData () {
      getStationByAssetId({ assetId: this.query.assetId }).then(res => {
        if (res && !res.errcode) {
          this.stationArray = res
        } else {
          this.stationArray = []
        }
      })
    },

    changePage (currentPage) {
      this.query.pageNumber = currentPage
      this.initPageData()
    },
    SearchData () {
      this.query.pageNumber = 1
      this.initPageData()
    },
    chkDevice (deviceId) {
      this.spinShow = true
      saveSpaceDevice({ deviceId: deviceId, spaceId: this.spaceId }).then(res => {
        this.$store.commit('set_space_update', new Date())
        // this.tableData = []
        // 重新加载数据
        this.initPageData()
        this.spinShow = false
      })

      // if (this.choiceDeviceIds.includes(deviceId)) {
      //   this.choiceDeviceIds.splice(this.choiceDeviceIds.indexOf(deviceId), 1)
      //   // this.choiceDeviceIdArray = this.choiceDeviceIdArray.filter(x => x !== deviceId)
      // } else {

      // }
    }
    // handleConfirmChk () {
    //   this.hideModal()
    //   this.$store.commit('set_investment_chkDeviceArray', this.choiceDeviceIds)
    // }

  },
  watch: {
    onlyChk () {
      this.SearchData()
    },
    deviceArray () {
      this.choiceDeviceIdArray = this.deviceArray.map(item => {
        return item.deviceId
      })
      // this.initPageData()
    }
  },
  computed: {
    // choiceDeviceIdArray () {
    //   return this.$store.state.rentalSpace.chkDeviceArray
    // },
    spaceId () {
      return this.$store.state.rentalSpace.spaceId
    }
  }
}
</script>
